import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../../shared';
import { CampanhaPipelineCardInfoEmAnaliseComponent } from './campanha-pipeline-card-info-em-analise.component';

@NgModule({
    imports: [
        SharedModule,
    ],
    declarations: [
        CampanhaPipelineCardInfoEmAnaliseComponent
    ],
    exports: [
        CampanhaPipelineCardInfoEmAnaliseComponent
    ]
})
export class CampanhaPipelineCardInfoEmAnaliseModule { }
